export const formatTime = (timeInSeconds: number): string => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const sec = Math.floor(timeInSeconds % 60);
    const decimal = (timeInSeconds % 1).toFixed(2).slice(1); // Gets the decimal part

    // Format with leading zeros if needed
    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');
    const ss = sec.toString().padStart(2, '0');

    return `${hh}:${mm}:${ss}`;
};

export const isWithinRange = (date: Date, from: Date, to: Date): boolean => {
    return date >= from && date <= to;
};